"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var Services_1 = require("../Services");
var NotificationAlert = /** @class */ (function (_super) {
    __extends(NotificationAlert, _super);
    function NotificationAlert(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    NotificationAlert.prototype.render = function () {
        var _this = this;
        return React.createElement(reactstrap_1.Alert, { color: "info", isOpen: true, toggle: function () { return Services_1.NotificationHandlerProvider.GetInstance().DismissNotification(_this.props.value); } }, this.props.value);
    };
    return NotificationAlert;
}(React.Component));
exports.NotificationAlert = NotificationAlert;
//# sourceMappingURL=NotificationAlert.js.map